import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileUploadModule } from "ng2-file-upload";
import { PdfpopupComponent } from './models/pdfpopup/pdfpopup.component';


@NgModule({
  declarations: [   PdfpopupComponent],
  imports: [
    MaterialModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FileUploadModule,

  ],
  exports: [
    MaterialModule,
    
    FileUploadModule,
    PdfpopupComponent
  ],


entryComponents: [
  PdfpopupComponent
  
  
 
]
})
export class SharedModule { }
